import { getPdfSimpliBaseURL } from "@/Services/base-url/api-constants";
import { CategoryName } from "@/utils/constant";
import {
  deleteCookie,
  getLinkWithLocale,
  readCookie,
} from "@/utils/helper";
import type { GenerateMusicResult } from "@/utils/generateMusic";
import { clearOnboardingSession } from "@/utils/onboardingSession";
import {
  buildSongForDisplayFilename,
  resolveRecipientDisplayNameFromCustomData,
} from "@/utils/onboardingData";
import {
  getMusicGenerationCustomData,
  saveMusicEditorQueryInfo,
  type MusicQueryExportOptions,
} from "@/utils/musicEditorQuery";
import {
  buildPdfSimpliAuthRedirectQuery,
  ensureVisitorCookiesReady,
} from "@/utils/visitor";

function withDashboardDisplayFilename(
  musicData: GenerateMusicResult,
  exportOptions?: MusicQueryExportOptions,
): GenerateMusicResult {
  const customData =
    exportOptions?.customData ??
    (musicData.musicId ? getMusicGenerationCustomData(musicData.musicId) : undefined);
  const recipientName = resolveRecipientDisplayNameFromCustomData(
    customData as Record<string, unknown> | undefined,
  );
  if (!recipientName) return musicData;
  return {
    ...musicData,
    filename: buildSongForDisplayFilename(recipientName, musicData.filename),
  };
}

export async function redirectToAuthPage(
  musicData: GenerateMusicResult,
  path: "account/signup" | "account/signin",
  locale = "",
  options?: {
    queryExportOptions?: MusicQueryExportOptions;
  },
): Promise<void> {
  const localeVal = locale ?? "";

  clearOnboardingSession();

  await ensureVisitorCookiesReady();

  const musicForQuery = withDashboardDisplayFilename(
    musicData,
    options?.queryExportOptions,
  );

  const saveQueryDataResponse = await saveMusicEditorQueryInfo(musicForQuery, {
    ...options?.queryExportOptions,
  });
  if (readCookie("sast")) {
    deleteCookie("sast");
  }

  const urlPost = `${getPdfSimpliBaseURL}/app`;
  const authParams: Record<string, string | null | undefined> = {
    querydata: saveQueryDataResponse,
    cname: CategoryName.MUSIC_GENERATOR_AI,
  };
  const queryString = buildPdfSimpliAuthRedirectQuery(authParams);
  const redirectPath =
    getLinkWithLocale(localeVal, path) + `?${queryString}`;
  window.location.assign(urlPost + redirectPath);
}
